// extracted by mini-css-extract-plugin
export var container = "styles-module--container--s+JPv";
export var fakeanchor = "styles-module--fakeanchor--ZNZv3";
export var image = "styles-module--image--uSXOQ";
export var imagecontainer = "styles-module--imagecontainer--0TCZV";
export var linkicon = "styles-module--linkicon--v4N04";
export var overlay = "styles-module--overlay--wI3pc";